import React from "react";
import ethImg from "../img/blogs.png";
import chainPattern from "../img/chain-pattern.png";
import chainPatterns from "../img/cubes.png";

const BlogPreview = () => {
  return (
    <div className=" md:mt-[-150px] mt-[-100] bg-[linear-gradient(180deg,#241D49_34.67%,#07031C_85.42%)] relative overflow-hidden min-h-screen px-6 md:px-20 py-20 text-white">
      
      {/* 🎨 Right-side decorative image */}
      <img
        src={chainPattern}
        alt="Decorative Cube Pattern"
        className="hidden md:block  mt-8 absolute right-0 top-28 h-auto w-[420px] z-0  pointer-events-none"
      />
      

           {/* 🎨 Right-side bottom  decorative image */}
      <img
        src={chainPatterns}
        alt="Decorative Cube Pattern"
        className="block md:hidden  mt-52 absolute right-0 top-28 h-auto w-[280px] z-0  pointer-events-none"
      />

      {/* Main Content */}
      <div className="relative z-10 max-w-6xl mx-auto">
        <h3 className="text-white text-2xl md:text-3xl font-normal mb-10 font-lato" >Blog</h3>

        <div className="flex flex-col md:flex-row md:items-center gap-8">
          {/* Left: Image */}
          <div className="w-full md:w-[300px] h-[300px] overflow-hidden rounded-lg shadow-md">
            <img
              src={ethImg}
              alt="Ethereum"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Right: Text */}
          <div className="flex-1 md:text-left h-[300px]">
            <h2 className="text-white text-[28px] md:text-[32px] font-normal leading-tight mb-4 font-istok">
              Frequently Asked <br /> Questions
            </h2>
            <p className="text-[#E1E1E1] text-[16px] md:text-base leading-relaxed mb-4 max-w-lg font-lato">
              Capital Nest is a premier crypto investment <br/> platform designed to support both beginners <br/>
              and seasoned investors in building, managing, <br/> and growing a diversified portfolio of digital<br/> assets.
            </p>
            <a
              href="/blog"
              className="text-[#F2C493] hover:underline font-medium text-base font-lato"
            >
              Read More
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPreview;
